export const reactContainerName = "fourpc-webscheduler-embed";
export const reactScrollParentName = "fourpc-webscheduler-embed-scroll";

export const MAIN_HEADER_COMPONENT_ID = "fourpc-webscheduler-main-header";

